import React, { Component } from 'react'
import TimeRow from '../time_row'
import * as fmt from '../../util/fmt_utils'
import * as timeUtils from '../../util/time_utils'
import * as dateUtils from '../../util/date_utils'
import { calcContainerHeight } from '../../util/scroll_display_utils'

function renderNoEntries() {
    return (
        <div className="time-entry-rollup-empty">
            <div className="no-entry-title">No entries for this date range</div>
            <div className="break-line"></div>
            <span className="no-entry-subtitle">Select a different range or create a new entry</span>
        </div>
    )
}

function renderRollupSumary(rollup, increment) {
    const date = new Date(rollup.date)
    const span = dateUtils.getDefaultTimespan(increment, date)
    const intervalName = dateUtils.isToday(date) ? 'Today' :
        dateUtils.isYesterday(date) ? 'Yesterday' :
            fmt.weekday(date)

    const dateRange = dateUtils.dateRangeString(increment, span, { hideYear: true })
    const totalHrs = timeUtils.msToHrsRounded(rollup.total)

    return (
        <div className="time-entry-summary">
            <span className="time-entry-day">{increment === 'Day' && intervalName}</span>
            <span className="time-entry-date">{dateRange}</span>
            <span className="time-entry-hours">Total: <span className="total-hours">{totalHrs}</span> hours</span>
        </div>
    )
}

function Rollup({ userId, timeEntries, createTimeEntry, updateTimeEntry, editTimeEntry,
    rollup, tags, increment, teams, suppressHeader, isCollapsed, openTimeEntryModal, showEditTooltips }) {

    const rollupClass = "time-entry-rollup" + (!isCollapsed ? " non-collapsed" : "") + (!suppressHeader ? " has-header" : "")
    const showNoEntries = !rollup || rollup.items.length === 0 ? renderNoEntries() : ''

    return (
        <div className="time-entry-rollups">
            {!suppressHeader && renderRollupSumary(rollup, increment)}

            <div className={rollupClass}>
                {rollup && rollup.items.map(item => <TimeRow
                    userId={userId}
                    timeEntries={timeEntries}
                    createTimeEntry={createTimeEntry}
                    updateTimeEntry={updateTimeEntry}
                    editTimeEntry={editTimeEntry}
                    isCollapsed={isCollapsed}
                    showEditTooltips={showEditTooltips}
                    tags={tags}
                    item={item}
                    key={item.id}
                    teams={teams}
                    openTimeEntryModal={openTimeEntryModal}
                />)}
                {showNoEntries}
            </div>
        </div>
    )
}

class TimeEntryList extends Component {
    constructor(props) {
        super(props)
        this.shouldShowEditTooltips = this.shouldShowEditTooltips.bind(this)

        this.state = {}

        this.ref = null

        this.setRef = el => {
            this.ref = el
        }
    }

    componentDidMount() {
        if(!this.props.showByUser) {
            this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
            window.addEventListener('resize', this.resizeScrollContainer)
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.trialEnd != this.props.trialEnd) {
            if(!this.props.showByUser) {
                this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeScrollContainer)
    }

    resizeScrollContainer = () => {
        this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
    }

    /**
     * Showtool tips when window width is wide and entries are not collapsed
     */
    shouldShowEditTooltips() {
        const { isMobile } = this.props
        return !this.props.isCollapsed && !isMobile
    }

    render() {
        const {
            createTimeEntry,
            updateTimeEntry,
            editTimeEntry,
            timeEntries,
            tags,
            teams,
            timeEntryRollups,
            increment,
            isCollapsed,
            openTimeEntryModal,
            userId,
            showByUser,
        } = this.props

        const { scrollWindowHeight } = this.state
        const showEditTooltips = this.shouldShowEditTooltips()

        const allRollupsEmpty = timeEntryRollups.every(rollup => rollup.items.length === 0)

        return (
            <div className= {showByUser ? "time-entry-list" : "time-entry-list scroll-window"} style={showByUser ? {height: "inherit"} : {height: scrollWindowHeight}} ref={this.setRef}>
                {allRollupsEmpty ?
                    <Rollup
                        userId={userId}
                        createTimeEntry={createTimeEntry}
                        updateTimeEntry={updateTimeEntry}
                        editTimeEntry={editTimeEntry}
                        timeEntries={timeEntries}
                        increment={increment}
                        teams={teams}
                        rollup={timeEntryRollups[0]}
                        tags={tags}
                        suppressHeader={true}
                        key={'rollup-empty'}
                        isCollapsed={isCollapsed}
                        showEditTooltips={showEditTooltips}
                        openTimeEntryModal={openTimeEntryModal}
                    />
                    :
                    timeEntryRollups.map((item, i) =>
                        <Rollup
                            userId={userId}
                            createTimeEntry={createTimeEntry}
                            updateTimeEntry={updateTimeEntry}
                            editTimeEntry={editTimeEntry}
                            timeEntries={timeEntries}
                            increment={increment}
                            teams={teams}
                            rollup={item}
                            tags={tags}
                            suppressHeader={timeEntryRollups.length < 2}
                            key={'rollup-' + i}
                            isCollapsed={isCollapsed}
                            showEditTooltips={showEditTooltips}
                            openTimeEntryModal={openTimeEntryModal}
                        />)
                }
            </div>
        )
    }
}

export default TimeEntryList



// WEBPACK FOOTER //
// ./src/components/layout/time_entry_list.jsx